module.exports = __webpack_public_path__ + "media/images/img_voice2-2a91868aa4f4d77a00b556f5d7e1b9c4.jpg";